var App = App || {};

App.PartialCarousel = (function ($) {
    "use strict";

    function init() {

        $("section.partial-carousel").each(function () {

            var $partialCarousel = $(this),
                $slides = $partialCarousel.find(".slides"),
                $photoSlides = $partialCarousel.find(".photos"),
                $promoSlides = $partialCarousel.find(".promos"),

                $controls = $partialCarousel.find(".controls"),
                $play = $controls.find(".play"),
                $pause = $controls.find(".pause");

            if ($photoSlides.length) {
                $photoSlides.slick({
                    autoplay: true,
                    autoplaySpeed: 5000,
                    appendDots: $("section.partial-carousel .controls .dots"),
                    arrows: false,
                    asNavFor: $promoSlides,
                    dots: true
                });

                $promoSlides.slick({
                    autoplay: true,
                    autoplaySpeed: 5000,
                    arrows: false,
                    asNavFor: $photoSlides,
                    dots: false,
                    fade: true
                });

                $play.hide();

                $play.on("click", function (e) {
                    e.preventDefault();

                    $slides.slick("slickPlay");

                    $(this).hide();
                    $pause.show();
                });

                $pause.on("click", function (e) {
                    e.preventDefault();

                    $slides.slick("slickPause");

                    $(this).hide();
                    $play.show();
                });
            }
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.PartialCarousel.init();
});